module.exports = __webpack_public_path__ + "static/supporters_center_img3@2x-1eac1f2695104ac9597ebb81b5a893ac.jpg";